import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stay-connected',
  templateUrl: './stay-connected.component.html',
  styleUrls: ['./stay-connected.component.css']
})
export class StayConnectedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
